import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormsModule, FormControl, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import { ApiServiceService } from "src/app/api-service.service";
import { AppUtility } from "src/app/interceptor/appUtitlity";
@Component({
  selector: 'app-generate-tool-form',
  templateUrl: './generate-tool-form.component.html',
  styleUrls: ['./generate-tool-form.component.scss']
})
export class GenerateToolFormComponent {
  @ViewChild('dataToExport', { static: false }) public dataToExport: ElementRef;

  breadcrumb = [
    {
      title: "Tool-loan-agreement-Generation",
      subTitle: "Dashboard"
    },
  ];
  signof: string;
  nameofguarntor: string;
  dateofguarntor: Date;
  uploadedFiles: { [key: number]: File } = {};
  updatedFileIndexes: number[] = [];
  supplierdata: any;
  editsupplierdata: any;
  ASNform: FormGroup;
  toolLoanForm: FormGroup;
  fileTouched: boolean[] = []; // Track if the file input has been touched
  formSubmitted = false;
  isdisabled: boolean = false;
  packagewisedetail: boolean = false;
  imagePreviews: any[] = []; // Ensure it's an empty array at the start
  previewImage: string | null = null;
  isDialogVisible: boolean = false; // Controls PrimeNG dialog visibility
  minDate: Date = new Date();
  constructor(
    private fb: FormBuilder,
    private _apiService: ApiServiceService,
    private __utility: AppUtility,
    private router: Router
  ) {
    this.ASNform = this.fb.group({
      docs: this.fb.array([])
    });

    this.toolLoanForm = this.fb.group({
      GuaranteeName: new FormControl(null, [Validators.required]),
      GuaranteeDate: new FormControl(null, [Validators.required]),
      confirmation: new FormControl(null, [Validators.requiredTrue]),
      title: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required]),
      Date: new FormControl(null, [Validators.required]),
      sub_address: new FormControl(null),
      sub_name: new FormControl(null),
      packageNumber: new FormControl({ value: '', disabled: true }), // added for package number
      bu: new FormControl({ value: '', disabled: true }), // added for bu
      businessUnit: new FormControl({ value: '', disabled: true }), // added for businessUnit
      poType: new FormControl({ value: '', disabled: true }), // added for poType
      orderNumber: new FormControl({ value: '', disabled: true }), // added for orderNumber
      supplierName: new FormControl({ value: '', disabled: true }) // added for supplierName

    })
  }
  ngOnInit(): void {
    this.supplierdata = history.state.packagedata;
    console.log(this.supplierdata);

    this.editsupplierdata = history.state.editpackagedata;
    console.log(this.supplierdata, "data");
    console.log(this.editsupplierdata, "editdata");
    if (this.editsupplierdata && this.editsupplierdata.length > 0) {
      this.editsupplierdata.forEach((tool: any, index: number) => {
        // Bind the image from the 'fileName' URL or another property
        if (tool.fileName && typeof tool.fileName === 'string') {
          console.log(tool.fileName, "error");
          this.imagePreviews[index] = tool.fileName;

          this.uploadedFiles[index] = {
            name: this.extractFileName(tool.fileName),
            type: this.getFileMimeType(tool.fileName)
          } as File;
        }
        this.toolLoanForm.controls['packageNumber'].setValue(tool.packageNumber);
        this.toolLoanForm.controls['bu'].setValue(tool.bu);
        this.toolLoanForm.controls['businessUnit'].setValue(tool.businessUnit);
        this.toolLoanForm.controls['poType'].setValue(tool.poType);
        this.toolLoanForm.controls['orderNumber'].setValue(tool.orderNumber);
        this.toolLoanForm.controls['supplierName'].setValue(tool.supplierName);
        this.toolLoanForm.controls['sub_name'].setValue(tool.subName);
        this.toolLoanForm.controls['sub_address'].setValue(tool.subName);
        this.toolLoanForm.controls['Date'].setValue(new Date(tool.date));
        this.toolLoanForm.controls['name'].setValue(tool.name);
        this.toolLoanForm.controls['title'].setValue(tool.title);
        this.toolLoanForm.controls['GuaranteeDate'].setValue(new Date(tool.guaranteeDate));
        this.toolLoanForm.controls['GuaranteeName'].setValue(tool.guaranteeName);
        this.toolLoanForm.controls['confirmation'].setValue(tool.confirmation);
        this.toolLoanForm.disable()
      });
    }
    else {
      this.toolLoanForm.controls['packageNumber'].setValue(this.supplierdata[0]?.packageNumber);
      this.toolLoanForm.controls['bu'].setValue(this.supplierdata[0]?.bu);
      this.toolLoanForm.controls['businessUnit'].setValue(this.supplierdata[0]?.businessUnit);
      this.toolLoanForm.controls['poType'].setValue(this.supplierdata[0]?.poType);
      this.toolLoanForm.controls['orderNumber'].setValue(this.supplierdata[0]?.orderNumber);
      this.toolLoanForm.controls['supplierName'].setValue(this.supplierdata[0]?.supplierName);
    }
  }

  getFileMimeType(fileName: string): string {
    const ext = fileName.split('.').pop()?.toLowerCase();
    switch (ext) {
      case 'pdf': return 'application/pdf';
      case 'jpg':
      case 'jpeg':
      case 'png': return 'image/png';
      default: return 'application/octet-stream';
    }
  }

  uploadDoc(event: Event, fileType: string, index?: number) {
    const file = (event.target as HTMLInputElement).files?.[0];

    if (!file || !(file instanceof File)) return;

    if (fileType === 'add_doc' && index !== undefined) {
      this.uploadedFiles[index] = file;
      if (!this.updatedFileIndexes.includes(index)) {
        this.updatedFileIndexes.push(index);
      }
      this.fileTouched[index] = true;
      // Create Image Preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreviews[index] = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  // Open Image in Simple Dialog
  openPreviewDialog(imageUrl: string) {
    this.previewImage = imageUrl;
    this.isDialogVisible = true;
  }


  // Close the Image Preview
  closePreviewDialog() {
    this.previewImage = null;
  }

  // Delete Image
  deleteImage(index: number) {
    this.uploadedFiles[index] = undefined as any;
    this.imagePreviews[index] = undefined as any;
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach(input => (input as HTMLInputElement).value = '');
  }


  async submitAll() {
    this.__utility.loader(true);

    const docsArray = this.ASNform.get('docs') as FormArray;
    docsArray.clear();
    const apiCalls = this.supplierdata.map((rowData, index) => {
      const formData = new FormData();
      formData.append('ToolLoanDetailIds', rowData.toolLoanDetailId);
      if (this.uploadedFiles && this.uploadedFiles[index]) {
        formData.append('file', this.uploadedFiles[index]);
      }
      return this._apiService.tooldocumentupload(formData)
        .then(response => {
          return { status: 'success', message: response.message };
        })
        .catch(error => {
          // return { status: 'error', message: error };
        });
    });

    try {
      const results = await Promise.all(apiCalls);
      this.__utility.loader(false);
      const successCount = results.filter(r => r.status === 'success').length;
      const errorCount = results.length - successCount;
      let finalMessage = `${successCount} documents uploaded successfully.`;
      if (errorCount > 0) {
        finalMessage += `  ${errorCount} documents failed to upload.`;
      }

      // this._apiService.showMessage(finalMessage, errorCount > 0 ? 'error' : 'success');
      this.uploadedFiles = [];
      this.isdisabled = true;
      setTimeout(() => {
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach(input => (input as HTMLInputElement).value = '');
      }, 100);

    } catch (error) {
      this.__utility.loader(false);
      this._apiService.showMessage('Something went wrong. Please try again.', 'error');
    }
  }

  saveform() {
    this.packagewisedetail = false;
    this.__utility.loader(true);
    let toolid = this.supplierdata[0].toolLoanMasterId;
    let supplierId = this.supplierdata[0].supplierId;
    function formatDateToDDMMYYYY(dateInput: any): string {
      const rawDate = new Date(dateInput);
      const day = String(rawDate.getDate()).padStart(2, '0');
      const month = String(rawDate.getMonth() + 1).padStart(2, '0');
      const year = rawDate.getFullYear();
      return `${day}-${month}-${year}`;
    }
    let payload = {
      GuaranteeName: this.toolLoanForm.value.GuaranteeName,
      GuaranteeDate: formatDateToDDMMYYYY(this.toolLoanForm.value['GuaranteeDate']),
      Confirmation: this.toolLoanForm.value.confirmation,
      Title: this.toolLoanForm.value.title,
      Name: this.toolLoanForm.value.name,
      Date: formatDateToDDMMYYYY(this.toolLoanForm.value['Date']),
      SubAddress: this.toolLoanForm.value.sub_address,
      SubName: this.toolLoanForm.value.sub_name,
      ToolLoanMasterId: toolid,
      SupplierId: supplierId
    };
    console.log(payload, "Data");

    this._apiService.updatetoolloan(payload).then(
      response => {
        this.__utility.loader(false);
        // this._apiService.showMessage(response.message, 'success');
        setTimeout(() => {

          this.router.navigateByUrl("/toolLoanAgreement");
        }, 1000);
      },
      error => {
        this._apiService.showMessage('error', error);
      }
    );

  }
  onSubmit() {
    this.formSubmitted = true;
    // Validate form fields
    if (this.toolLoanForm.invalid) {
      this._apiService.showMessage('Please fill in all required fields.', 'error');
      return;
    }

    // Validate file uploads (each row must have a file)
    if (this.supplierdata.some((_, index) => !this.uploadedFiles[index])) {
      this._apiService.showMessage('Please upload Photos', 'error');
      return;
    }

    this.__utility.loader(true);

    Promise.all([this.submitAll(), this.saveform()])
      .then(() => {
        this.__utility.loader(false);
        this._apiService.showMessage('Form saved and documents uploaded successfully!', 'success');
        this.router.navigateByUrl("/toolLoanAgreement");
      })
      .catch(() => {
        this.__utility.loader(false);
        this._apiService.showMessage('Something went wrong. Please try again.', 'error');
      });
  }

  openagreement() {
    this.packagewisedetail = true
  }
  public exportPdf(): void {
    if (this.dataToExport) {
      this.__utility.downloadAsPdf(
        this.dataToExport.nativeElement,
        this.supplierdata[0].supplierName
      );
    }
  }
  isImageFile(file: any): boolean {
    const name = file?.name || file;
    return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(name);
  }
  extractFileName(url: string): string {
    if (typeof url === 'string') {
      // Remove query params if present (anything after ?)
      const cleanUrl = url.split('?')[0];
      // If it's a full path, get only the last segment
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    }
    return url;
  }
  async updatedoc() {
    this.__utility.loader(true);

    const docsArray = this.ASNform.get('docs') as FormArray;
    docsArray.clear();
    console.log(this.uploadedFiles, "data fiel");

    const apiCalls = this.updatedFileIndexes.map((index) => {
      const rowData = this.editsupplierdata[index];
      const formData = new FormData();
      formData.append('ToolLoanDetailIds', rowData.toolLoanDetailId);
      if (this.uploadedFiles && this.uploadedFiles[index] instanceof File) {
        formData.append('file', this.uploadedFiles[index]);
      }
      return this._apiService.updatetoolagreementdoc(formData)
        .then(response => {
          return { status: 'success', message: response };
        })
        .catch(error => {
          return { status: 'error', message: error };
        });
    });
    try {
      const results = await Promise.all(apiCalls);
      this.__utility.loader(false);
      const successCount = results.filter(r => r.status === 'success').length;
      const errorCount = results.length - successCount;
      let finalMessage = `${successCount} documents uploaded successfully.`;
      if (errorCount > 0) {
        finalMessage += `  ${errorCount} documents failed to upload.`;
      }
      this.__utility.loader(false);
      this._apiService.showMessage(finalMessage, errorCount > 0 ? 'error' : 'success');
      this.router.navigateByUrl("/toolLoanAgreement");
      this.uploadedFiles = [];
      this.isdisabled = true;
      setTimeout(() => {
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach(input => (input as HTMLInputElement).value = '');
      }, 100);

    } catch (error) {
      this.__utility.loader(false);
      this._apiService.showMessage('Something went wrong. Please try again.', 'error');
    }
  }
}
